export default "__VITE_ASSET__DFXGPuxW__"